import React from "react";
import { HeroComponentDisplay } from "cms/components/components/hero/display/index";
import { HeroComponentEditor } from "cms/components/components/hero/edit/index";
import { getComponentZoneLayout } from "cms/components/components/component";

// This component is basically the cloned of HeroCaraousel component.
const HeroComponent = (props) => {
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <HeroComponentDisplay />,
        editComponent: <HeroComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

HeroComponent.displayName = "HeroComponent";
export { HeroComponent };
